export const getFormattedDateTime = dateTime => {
	const convertedDateTime = new Date(dateTime);

	const options = {
		year: 'numeric',
		month: '2-digit',
		day: '2-digit',
		hour: '2-digit',
		minute: '2-digit',
		hour12: true,
	};

	const formattedDateString = convertedDateTime.toLocaleDateString(
		'en-US',
		options
	);
	return formattedDateString;
};

export const getDate = dateTime => {
	const convertedDateTime = new Date(dateTime);

	const options = {
		year: 'numeric',
		month: '2-digit',
		day: '2-digit',
	};

	return convertedDateTime.toLocaleDateString('en-US', options);
};

export const getTime = dateTime => {
	const convertedDateTime = new Date(dateTime);

	const options = {
		hour: '2-digit',
		minute: '2-digit',
		hour12: true,
	};

	return convertedDateTime.toLocaleTimeString('en-US', options);
};

export const getFullMonthDate = dateTime => {
	// Returns Month Date, Year - e.g. October 24, 2024
	const convertedDateTime = new Date(dateTime);

	const options = {
		month: 'long',
		day: '2-digit',
		year: 'numeric',
	};

	return new Intl.DateTimeFormat('en-US', options).format(convertedDateTime);
};
